module.exports = __webpack_public_path__ + "static/media/slide02.4453b196.jpg";